module.exports = __webpack_public_path__ + "school/img/practiceSeparateMedicineThemeBg.72626b99.jpg";